export default __webpack_public_path__ + "static/pn-b3fc2087af0c8423bfacd3aaccc799f8.svg";